import cn from "classnames";
import { FC } from "react";
import { TestQuestion, TestQuestionType } from "types/testProcess.types";
import { Radio } from "../../inputs/Radio";
import { Multi } from "../../inputs/Multi";
import { Dropdown } from "../../inputs/Dropdown";
import { TextBox } from "../../inputs/TextBox";
import { TextArea } from "../../inputs/TextArea";
import { Numeric } from "../../inputs/Numeric";
import styles from "./Question.module.scss";

const map: Record<TestQuestionType, FC<any>> = {
  radio: Radio,
  multi: Multi,
  dropdown: Dropdown,
  text_box: TextBox,
  text_area: TextArea,
  numeric: Numeric,
};

interface Props {
  question: TestQuestion;
  isIntro?: boolean;
  disabled?: boolean;
  placeholder?: string;
  questionsAnswered?: Map<string, boolean>;
  setquestionsAnswered?: React.Dispatch<
    React.SetStateAction<Map<string, boolean>>
  >;
}

export const Question: FC<Props> = ({
  question,
  isIntro = false,
  disabled,
  placeholder,
  questionsAnswered,
  setquestionsAnswered,
}) => {
  const Component = map[question.type];

  return (
    <div
      className={cn(
        styles.question,
        isIntro && styles.intro,
        !isIntro && disabled && styles.disabled
      )}
    >
      <h6 className={cn(styles.question__title, "mb-15")}>
        <span className={styles.question__number}>
          {!isIntro && `${question.order}`}
        </span>
        {question.question}
      </h6>
      <Component
        question={question}
        disabled={disabled}
        placeholder={placeholder}
        questionsAnswered={questionsAnswered}
        setquestionsAnswered={setquestionsAnswered}
      />
    </div>
  );
};
